module.exports = __webpack_public_path__ + "img/finance.6bde52bc.svg";